export default class RouteActions {

    static BEFORE_ASSIGN='BEFORE_ASSIGN'
    static AFTER_ASSIGN='AFTER_ASSIGN'

    static BEFORE_REVOKE=''
    static AFTER_REVOKE='AFTER_REVOKE'

    static beforeAssign(){
      return {
        type: RouteActions.BEFORE_ASSIGN
      };
    }

    static afterAssign(data){
      return {
        type: RouteActions.AFTER_ASSIGN,
        payload:data
      };
    }

    static beforeRevoke(){
      return {
        type: RouteActions.BEFORE_REVOKE
      };
    }

    static afterRevoke(data){
      return {
        type: RouteActions.AFTER_REVOKE,
        payload:data
      };
    }


  


    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static RESET_LIST='RESET_LIST';
    static GET_HELPER='GET_HELPER';




    static submit(){
      return {
        type: RouteActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: RouteActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: RouteActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: RouteActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: RouteActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: RouteActions.SHOW_DATA,
        payload: data
      };
    }
    static resetList() {
      return {
        type: RouteActions.RESET_LIST
      };
    }
    static error(error){
      return {
        type: RouteActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: RouteActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: RouteActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: RouteActions.RESET_DATA,
      };
    }
    static errorInternal(error){
      return {
        type: RouteActions.ERROR_SERVER,
        payload: error
      };
    }
    static helper(data){
        return {
          type: RouteActions.GET_HELPER,
          payload: data
        };
      }
  }
  
  